import { URL_PREFIX } from '../constants/api';

export enum UserRole {
  Anonymous = 0,
  User,
  Supervisor,
  Admin,
}

export interface CurrentAmplifyUser {
  id: number;
  name: string;
  email: string;
  role: 'user' | 'admin' | 'supervisor';
  feature_flags?: Record<string, boolean>;
}

export const getCurrentAmplifyUser = async (): Promise<CurrentAmplifyUser> => {
  const url = `${URL_PREFIX}/api/v1/users/me`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch current user: ${response.statusText}`);
    }

    const user: CurrentAmplifyUser = await response.json();

    return user;
  } catch (error) {
    console.warn('Failed to fetch current user:', error);

    throw error;
  }
};
